import { render, staticRenderFns } from "./settings-account-personal-devices.vue?vue&type=template&id=53358200&scoped=true&"
import script from "./settings-account-personal-devices.vue?vue&type=script&lang=js&"
export * from "./settings-account-personal-devices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53358200",
  null
  
)

export default component.exports